/**
 * Round a number to a maximum of maxDP decimal places
 */
export default function roundFloat(n: number, maxDP: number): number {
  return Math.round((n + Number.EPSILON) * 10 ** maxDP) / 10 ** maxDP;
}
